import {Micropost} from '../types'

// Merge fetched pages into the local list, deduping by micropost ID and
// keeping the existing (local) entry when IDs collide. This preserves
// client-side mutations (create/update/delete) instead of letting a stale
// server page resurrect or revert them.
//
// Tradeoff: because local always wins on collision, a *server-side* edit to a
// post already in the local list (e.g. made by another admin) is intentionally
// NOT reflected on pagination/refetch — it only appears after a full remount
// re-seeds the list. That is an accepted cost of protecting in-flight local
// mutations; revisit with last-write-wins (keyed on UpdateDate) if cross-admin
// edit visibility becomes a requirement.
export const mergeMicropostsById = (
  existing: Micropost[],
  incoming: Micropost[],
): Micropost[] => {
  const existingIDs = new Set(existing.map((mp) => mp.ID))

  return [...existing, ...incoming.filter((mp) => !existingIDs.has(mp.ID))]
}
